import {
  AttachmentAdapter,
  PendingAttachment,
  CompleteAttachment,
} from '@assistant-ui/react';

class DocumentAttachmentAdapter implements AttachmentAdapter {

  accept = 'application/pdf'; // ,.doc,.xls,.xlsx,.docx,.csv

  add({ file }: { file: File }): Promise<PendingAttachment> {
    // Validate file size
    const maxSize = 10 * 1024 * 1024; // 10MB limit
    if (file.size > maxSize) {
      throw new Error('PDF size exceeds 10MB limit');
    }
    return {
      id: crypto.randomUUID(),
      type: 'document',
      name: file.name,
      file,
      contentType: file.type,
      status: { type: 'running', },
    };
  }

  async send(attachment: PendingAttachment): Promise<CompleteAttachment> {
    // Option 1: Extract text from PDF (requires pdf parsing library)
    // const text = await this.extractTextFromPDF(attachment.file);
    // Option 2: Convert to base64 for API processing
    const base64Data = await this.fileToBase64(attachment.file);
    return {
      id: attachment.id,
      type: 'document',
      name: attachment.name,
      content: [
        {
          type: 'file',
          data: `data:${attachment.file.type};base64,${base64Data}`,
          mimeType: attachment.file.type
        },
      ],
      status: { type: 'complete' },
    };
  }

  remove(attachment: PendingAttachment): Promise<void> {
    // Cleanup if needed
    console.log(attachment);
    return new Promise((v) => { console.log(v); });
  }

  private async fileToBase64(file: File): Promise<string> {
    const arrayBuffer = await file.arrayBuffer();
    const bytes = new Uint8Array(arrayBuffer);
    let binary = '';
    bytes.forEach((byte) => {
      binary += String.fromCharCode(byte);
    });
    return btoa(binary);
  }
}

export default DocumentAttachmentAdapter;
